var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStok(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "layer",
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M6.054.138,9.769,1.747c1.07.461,1.07,1.222,0,1.683L6.054,5.039a2.2,2.2,0,0,1-1.536,0L.8,3.43c-1.07-.461-1.07-1.222,0-1.683L4.518.138A2.2,2.2,0,0,1,6.054.138Z",
    transform: "translate(2.085 1.655)",
    fill: "none",
    stroke: "#252525",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Vector-2",
    "data-name": "Vector",
    d: "M0,0A1.572,1.572,0,0,0,.88,1.32L5.148,3.175a1.277,1.277,0,0,0,1.018,0L10.435,1.32A1.572,1.572,0,0,0,11.315,0",
    transform: "translate(1.842 6.909)",
    fill: "none",
    stroke: "#252525",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Vector-3",
    "data-name": "Vector",
    d: "M0,0A1.447,1.447,0,0,0,.88,1.32L5.148,3.175a1.277,1.277,0,0,0,1.018,0L10.435,1.32A1.447,1.447,0,0,0,11.315,0",
    transform: "translate(1.842 10.087)",
    fill: "none",
    stroke: "#252525",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Vector-4",
    "data-name": "Vector",
    d: "M0,0H15V15H0Z",
    fill: "none",
    opacity: 0
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStok);
export default __webpack_public_path__ + "static/media/stok.1862f4ac39f230174612d9facdbe3db8.svg";
export { ForwardRef as ReactComponent };